export default __webpack_public_path__ + "static/media/HeyRead.9142f2af.png";